<template>
  <div class="br-subleft overflow-y-auto" :data-min="leftsideStatus">
    <!--<div class="left-side-switch" onclick="sideChangeStatus();">
      <i class="fa" :class="leftsideStatus ? 'fa-angle-double-right':'fa-angle-double-left'"></i>
    </div>-->
    <div>
      <h6
        class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
      >
        {{ $t("express.条件筛选") }}
      </h6>
      <div class="mg-t-20 pd-x-10 mg-b-40">
        <div class="mg-b-10 form-group">
          <input
            type="text"
            :placeholder="$t('express.标签名称')"
            class="form-control form-control-dark tx-14"
            v-model="name"
            @keyup.enter="filtrate"
          />
        </div>
        <div v-if="loginType == '2'" class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            v-model="type"
            @change="filtrate"
          >
            <option value="">{{ $t("express.选择类型") }}</option>
            <option v-for="(s, k) in typeArr" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            v-model="specType"
            @change="filtrate"
          >
            <option value="">{{ $t("express.选择规格") }}</option>
            <option v-for="(s, k) in specTypeArr" :key="k" :value="k">
              {{ k == 99 ? $t(s) : s }}
            </option>
          </select>
        </div>
        <div class="mg-b-20 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            v-model="status"
            @change="filtrate"
          >
            <option value="">{{ $t("express.选择状态") }}</option>
            <option v-for="(s, k) in statusArr" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate"
    >
      {{ $t("express.筛 选") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["leftsideStatus", "fStatus", "fName", "fSpecType", "fType"],
  data() {
    return {
      loginType: localStorage.getItem("loginType"),
      statusArr: arrDict.labelStatus,
      specTypeArr: arrDict.labelSpecType,
      typeArr: arrDict.labelType,
      name: this.fName,
      status: this.fStatus,
      specType: this.fSpecType,
      type: this.fType,
    };
  },
  watch: {
    fName: function () {
      this.name = this.fName;
    },
    fStatus: function () {
      this.status = this.fStatus;
    },
    fSpecType: function () {
      this.specType = this.fSpecType;
    },
    ftype: function () {
      this.type = this.fType;
    },
  },
  methods: {
    sideChangeStatus() {
      //边栏状态改变
      this.$emit("changeStatus");
    },
    filtrate() {
      this.$emit("filtrate", this.status, this.name, this.specType, this.type);
    },
  },
  mounted() {
    $(".overflow-y-auto").perfectScrollbar();
  },
};
</script>
